module.exports = __webpack_public_path__ + "img/filter2.1648dbc2.svg";